import get from 'lodash/get';

import { createSelector } from 'reselect';

export const selectRootState = state =>
  get(state, 'managePatientInsurances.updatePatientInsurance');

export const selectUpdatePatientInsuranceError = createSelector(
  selectRootState,
  state => get(state, 'error'),
);



// WEBPACK FOOTER //
// ./src/redux/manage-insurances/selectors/update-patient-insurance.js